import styled from 'styled-components';

export const Background = styled.div`
margin-top: 48px;
`;
